export default __webpack_public_path__ + "static/media/ic_chevron_left.57e344ec.svg";